import { useState } from 'react';
import { Input, TransparentLoader } from '../..';
import { PhotoIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';

interface Props {
  loading: boolean;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  multiple?: boolean;
  accept?: string;
  /** Callback invocata al drop di file nell'area (drag & drop). */
  onDropFiles?: (files: FileList) => void;
}

const FileUpload = ({
  loading,
  handleFileChange,
  multiple = false,
  accept,
  onDropFiles,
}: Props) => {
  const { t } = useTranslation();
  const [dragActive, setDragActive] = useState(false);

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (!loading) setDragActive(true);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (loading) return;
    const files = e.dataTransfer?.files;
    if (files && files.length > 0) {
      onDropFiles?.(files);
    }
  };

  return (
    <div className="col-span-full w-full">
      <div
        onDragOver={handleDragOver}
        onDragEnter={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        className={`mt-2 flex justify-center rounded-lg border border-dashed px-6 py-10 ${
          dragActive
            ? 'border-indigo-500 bg-indigo-50 dark:bg-grey'
            : 'border-gray-900/25'
        }`}
      >
        <div className="text-center">
          {loading ? (
            <div className="flex justify-center">
              <TransparentLoader />
            </div>
          ) : (
            <PhotoIcon
              className="mx-auto h-12 w-12 text-gray-300"
              aria-hidden="true"
            />
          )}
          <div className="mt-4 flex text-sm leading-6 text-gray-600">
            <label
              htmlFor="fileUpload"
              className={`relative ${loading ? '' : 'cursor-pointer'}
           rounded-md bg-white font-semibold ${
             loading ? 'text-gray-600' : 'text-indigo-600'
           } focus-within:outline-none  ${
             loading ? '' : 'hover:text-indigo-500'
           }`}
            >
              <span>{t('fileUpload.title')}</span>
              <Input
                type="file"
                id="fileUpload"
                name="fileUpload"
                className="sr-only"
                onChange={handleFileChange}
                multiple={multiple}
                accept={accept}
              />
            </label>
            <p className="pl-1">{t('fileUpload.dragAnDrop')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FileUpload;
